import { useSelector } from 'react-redux'

import { BLACK_FRIDAY_DISCOUNT } from 'routes/Home/homeConfig'
import { useDiscountDescriptor } from 'routes/Menu/components/BoxSummary/Banner/PriceAndDiscountTip/priceAndDiscountTipUtils'
import { getPromoCode } from 'selectors/basket'

import { formatDiscountTip } from './discountAppliedBarUtils'

export const DISCOUNT_TEXT = {
  blackFriday: {
    title: 'Applied:',
    body: 'off first box + 8th box FREE',
  },
  default: {
    title: 'Discount applied:',
    body: 'off first order',
  },
} as const

export const useDiscountAppliedData = () => {
  const discountDescriptor = useDiscountDescriptor()
  const { isDiscountEnabled } = discountDescriptor
  const basketPromo = useSelector(getPromoCode)

  const discountAmount = formatDiscountTip(discountDescriptor)

  const isBlackFridayDiscountApplied = basketPromo === BLACK_FRIDAY_DISCOUNT.defaultPromoCode

  const { title: discountAppliedTitle, body: discountAppliedBody } = isBlackFridayDiscountApplied
    ? DISCOUNT_TEXT.blackFriday
    : DISCOUNT_TEXT.default

  if (!isDiscountEnabled) {
    return {
      discountAppliedTitle: null,
      discountAppliedBody: null,
      discountAmount: null,
      isDiscountEnabled,
    }
  }

  return {
    discountAppliedTitle,
    discountAppliedBody,
    isDiscountEnabled,
    discountAmount,
  }
}
